import type { UserRole } from '../stores/authStore';

export type ProductRole = 'Owner' | 'Asset Owner' | 'Fund' | 'QE Operator' | 'Admin';

export function getDisplayRole(rawRole?: UserRole | string | null): ProductRole {
  switch (rawRole) {
    case 'person':
      return 'Owner';
    case 'enterprise':
      return 'Asset Owner';
    case 'investor':
    case 'buyer':
      return 'Fund';
    case 'operator':
      return 'QE Operator';
    case 'admin':
    case 'dev':
      return 'Admin';
    default:
      return 'Owner';
  }
}
